import { DialogCheckBox } from 'components/DialogCheckBox';
import { useRepresentative } from 'hooks/useRepresentative';
import { useDisclose } from 'hooks/utilHooks';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { IRepresentant } from 'types/Representant';
import { maskCpf } from 'util/masks';

import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import {
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { styled } from '@mui/styles';

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#fafafa',
  },
}));

const StyledTableCell = styled(TableCell)(() => ({
  color: '#4B4B4B',
}));

export interface IRepresentativeRow {
  representative: IRepresentant;
}

export const RepresentativeRow: React.FC<IRepresentativeRow> = ({
  representative,
}) => {
  const { isOpen, onClose, onOpen } = useDisclose();
  const { loadingDelete, deleteRepresentative } = useRepresentative();

  const history = useHistory();
  const { path } = useRouteMatch();

  const handleView = () => {
    history.push(`${path}/view/${representative._id}`);
  };

  const deleteItem = () => {
    deleteRepresentative(representative._id);

    onClose();
  };

  const handleEdit = () => {
    history.push(`${path}/edit/${representative._id}`);
  };

  return (
    <>
      <StyledTableRow>
        <StyledTableCell>{representative.name}</StyledTableCell>

        <StyledTableCell>{maskCpf(representative.cpf)}</StyledTableCell>

        <StyledTableCell>
          <Typography
            fontSize={14}
            color={representative.active ? '#4CAF50' : '#F24E1E'}
          >
            {representative.active ? 'Ativo' : 'Inativo'}
          </Typography>
        </StyledTableCell>

        <TableCell align="right">
          <Stack flexDirection="row" gap="8px" justifyContent="flex-end">
            <Tooltip title="Editar">
              <IconButton
                aria-label="edit"
                color="inherit"
                onClick={handleEdit}
              >
                <CreateIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Ver mais">
              <IconButton
                aria-label="info"
                color="inherit"
                onClick={handleView}
              >
                <SearchIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Apagar">
              <IconButton aria-label="delete" color="inherit" onClick={onOpen}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Stack>
        </TableCell>
      </StyledTableRow>
      <DialogCheckBox
        title="Exclusão permanente"
        text="Essa ação é permanente, você deseja continuar e excluir todos os
        dados desse representante?"
        isOpen={isOpen}
        onClose={onClose}
        loadingDelete={loadingDelete}
        deleteItem={deleteItem}
      />
    </>
  );
};

